export default {
  /**
   * COMMON ERRORS
   */
  'Server error': 'Oooops! Something is wrong!',
  'Unknown error': 'Oooops! Something is wrong!',
  'No Data': 'No Data',
  'No data': 'No data',

  /**
   * ******* ACTIONS ********
   */
  created: 'created',
  deleted: 'deleted',
  updated: 'updated',
  uploaded: 'uploaded',
  Create: 'Create',
  Delete: 'Delete',
  'Delete all': 'Delete all',
  Save: 'Save',
  Edit: 'Edit',
  View: 'View',
  Cancel: 'Cancel',
  Add: 'Add',
  Close: 'Close',
  Updated: 'Updated',
  Uploaded: 'Uploaded',
  Deleted: 'Deleted',
  'Sold to': 'Sold to',
  'Ship to': 'Ship to',
  Created: 'Created',
  Download: 'Download',
  Refresh: 'Refresh',
  Search: 'Search',
  Logout: 'Logout',
  Login: 'Login',
  Bind: 'Bind',
  Insert: 'Insert',
  Copy: 'Copy',
  'Copy from': 'Copy from',
  'Go back': 'Go back',
  'Type a query': 'Type a query',

  /**
   * ****** NOUNS *********
   */

  /**
   * Nouns without articles
   */
  Yes: 'Yes',
  No: 'No',
  Name: 'Name',
  Category: 'Category',
  Brand: 'Brand',
  Size: 'Size',
  Color: 'Color',
  Code: 'Code',
  Style: 'Style',
  Price: 'Price',
  Cost: 'Cost',
  Width: 'Width',
  Height: 'Height',
  Weight: 'Weight',
  Filter: 'Filter',
  Status: 'Status',
  Route: 'Route',
  Carrier: 'Carrier',
  Address: 'Address',
  Customer: 'Customer',
  History: 'History',
  Summary: 'Summary',
  Store: 'Store',
  Title: 'Title',
  'Short description': 'Short description',
  'Full description': 'Full description',
  Market: 'Market',
  Marketplace: 'Marketplace',
  Quantity: 'Quantity',
  'Order quantity': 'Order quantity',
  Vendor: 'Vendor',
  Value: 'Value',
  Settings: 'Settings',
  Help: 'Help',
  List: 'List',
  Shipment: 'Shipment',
  Attribute: 'Attribute',
  Image: 'Image',
  Note: 'Note',
  Keyword: 'Keyword',
  Bullet: 'Bullet',
  Variation: 'Variation',
  Item: 'Item',
  Order: 'Order',
  'Customer Email': 'Customer Email',
  Company: 'Company',
  Country: 'Country',
  Qty: 'Qty',
  Age: 'Age',
  'Requested Service': 'Requested Service',
  State: 'State',
  'Begin date': 'Begin date',
  'End date': 'End date',
  Type: 'Type',
  'Filter name': 'Filter name',
  'Days of week': 'Days of week',
  Inventory: 'Inventory',
  'Marketplace name': 'Marketplace name',
  Currency: 'Currency',
  Credentials: 'Credentials',
  Password: 'Password',
  Dashboard: 'Dashboard',
  Home: 'Home',
  'Item name': 'Item name',
  General: 'General',
  ALL: 'ALL',
  Error: 'Error',
  Problem: 'Problem',
  Shipping: 'Shipping',
  'Full Name': 'Full Name',
  Parent: 'Parent',
  'Default value': 'Default value',
  SKUs: 'SKUs',
  Description: 'Description',
  Number: 'Number',
  Text: 'Text',
  'First name': 'First name',
  'Last name': 'Last name',
  Email: 'Email',
  'Account name': 'Account name',
  'New password': 'New password',
  Main: 'Main',

  /**
   * Nouns with articles
   */
  'An attribute': 'An attribute',
  'An attribute value': 'An attribute value',
  'An item': 'An item',
  'An item variation': 'An item variation',
  'An item style': 'An item style',
  'An item image': 'An item image',
  'An order': 'An order',
  'A brand': 'A brand',
  'A marketplace': 'A marketplace',
  'A vendor': 'A vendor',
  'A category': 'A category',
  'A report': 'A report',
  'A store': 'A store',
  'A size': 'A size',
  'A color': 'A color',

  /**
   * Nouns countable
   */
  Shipments: 'Shipment | Shipments',
  Attributes: 'Attribute | Attributes',
  Images: 'Image | Images',
  Notes: 'Note | Notes',
  Keywords: 'Keyword | Keywords',
  Bullets: 'Bullet | Bullets',
  Variations: 'Variation | Variations',
  Items: 'Item | Items',
  Styles: 'Style | Styles',
  Vendors: 'Vendor | Vendors',
  Marketplaces: 'Marketplace | Marketplaces',
  Brands: 'Brand | Brands',
  Params: 'Param | Params',
  Hours: 'Hour | Hours',
  Actions: 'Action | Actions',
  Filters: 'Filter | Filters',
  Orders: 'Order | Orders',
  Products: 'Product | Products',
  Reports: 'Report | Reports',
  Logs: 'Log | Logs',
  'Inventory filters': 'Inventory filter | Inventory filters',
  Values: 'Value | Values',
  Stores: 'Store | Stores',
  Categories: 'Category | Categories',
  Templates: 'Template | Templates',
  Variables: 'Variable | Variables',
  Columns: 'Column | Columns',
  Labels: 'Label | Labels',
  Keys: 'Key | Keys',
  'Credential Fields': 'Credential Field | Credential Fields',
  Users: 'User | Users',
  Accounts: 'Account | Accounts',
  Roles: 'Role | Roles',
  Admins: 'Admin | Admins',
  Managers: 'Manager | Managers',
  Fields: 'Field | Fields',
  Types: 'Type | Types',
  Domains: 'Domain | Domains',
  Languages: 'Language | Languages',
  'Colors Maps': 'Color Map | Colors Maps',
  'Sizes Maps': 'Sizes Map | Sizes Maps',

  /**
   * ADJECTIVES
   */
  Imported: 'Imported',
  Enabled: 'Enabled',
  Required: 'Required',
  Default: 'Default',
  New: 'New',
  'In Progress': 'In Progress',
  Completed: 'Completed',

  /**
   * ******** COMMON PHRASES *********
   */
  /**
   * Without variables
   */
  'Quick filters': 'Quick filters',
  'Clear filters': 'Clear filters',
  None: 'None',
  Active: 'Active',
  'In Pack': 'In Pack',
  'No code': 'No Code',
  Loading: 'Loading',
  'Are you sure?': 'Are you sure?',
  'Go to dashboard': 'Go to dashboard',
  /**
   * With variables
   */
  Action: '{object} has been {action}.',
  'An Object is not specified': '{object} isn\'t specified',
  'Please select': 'Please select {object}',
  'Select object': 'Select {object}',
  'Press Enter to add a new object': 'Press Enter to add a new {object}',
  'Please fill the form': 'Please fill all required fields in the form!',
  'Edit object': 'Edit {object}',
  'Create object': 'Create {object}',
  'Add object': 'Add {object}',
  'Add new object': 'Add new {object}',

  /**
   * ******** COMPONENTS *********
   */

  /**
   * Drop Downs
   */
  'Please select...': 'Please select...',
  'Type to search or add object': 'Type to search or add {object}',
  'Type to search object': 'Type to search {object}',
  'Add this as a new object': 'Add this as a new {object}',

  /**
   * Data Table
   */
  'Visible columns': 'Visible columns',
  'Total rows': 'Total rows',
  'Per page': 'Per page',
  Selected: 'Selected',
  // Filters
  'Add Filter': 'Add Filter',
  'more than': 'more than',
  equal: 'equal',
  'less than': 'less than',
  'begin with': 'begin with',
  contains: 'contains',

  /**
   * Products/Items
   * */
  'Don\'t forget to save changes.': 'Don\'t forget to save changes.',
  'Without color': 'Without color',
  'Choose images': 'Choose images',
  'Upload images': 'Upload images',
  'SKUs for variation': 'SKUs for variation',
  'Add SKU for variation': 'Add SKU for variation',
  'An item doesn\'t have any variation.': 'An item doesn\'t have any variation.',

  /**
   * Orders
   */
  'Order Date': 'Order Date',
  'Paid Date': 'Paid Date',
  'Ship Date': 'Ship Date',
  'Product Total': 'Product Total',
  'Shipping Paid': 'Shipping Paid',
  'Tax Paid': 'Tax Paid',
  'Total Order': 'Total Order',
  'Total Paid': 'Total Paid',
  'Item(s) ordered (count)': 'Item(s) ordered ({count})',
  'Multiple items (count)': 'Multiple items ({count})',
  // Orders statuses
  'Order Status Pending': 'Pending',
  'Order Status Staging to unshipped': 'Staging to unshipped',
  'Order Status Unshipped': 'Unshipped',
  'Order Status Staging to shipped': 'Staging to shipped',
  'Order Status Shipped': 'Shipped',
  'Order Status Reserved': 'Reserved',
  'Order Status Refunded': 'Refunded',
  'Order Status Canceled': 'Canceled',
  'Order Status Shipping': 'Shipping',
  'Order Status Problem': 'Problem',
  // Notes types
  'Note Type From Buyer': 'From Buyer',
  'Note Type To Buyer': 'To Buyer',
  'Note Type Internal': 'Internal',
  // Shipments statuses
  'Shipment Status Opened': 'Opened',
  'Shipment Status Pending': 'Pending',
  'Shipment Status Submitted': 'Submitted',
  'Shipment Status Acknowleged': 'Acknowleged',
  'Shipment Status Accepted': 'Accepted',
  'Shipment Status Shipped': 'Shipped',
  'Shipment Status Rejected': 'Rejected',
  'Shipment Status QTY not available': 'QTY not available',
  'Shipment Status QTY canceled': 'QTY canceled',
  'Shipment Status Canceled': 'Canceled',
  'Shipment Status DNO': 'DNO',
  // Shipments types
  'Shipment Type Batch': 'Batch',
  'Shipment Type Drop': 'Drop',

  /**
   * Orders SideBar
   */
  'There is not any shipment': 'There is not any shipment',
  'There are not any actions for this order.': 'There are not any actions for this order.',
  'View a history log': 'View a history log',

  /**
   * 404 page
   */
  'Oops! You\'re lost.': 'Oops! You\'re lost.',
  'The page you are looking for was not found.': 'The page you are looking for was not found.',

  /**
   * Reports
   */
  'A report will be sent to this email after creating.': 'A report will be sent to this email after creating.',
  'Min Qty difference %': 'Min Qty difference %',
  'Orders IDs (in our DB)': 'Orders IDs (in our DB)',
  'MP Orders IDs (in Marketplaces)': 'MP Orders IDs (in Marketplaces)',
  'Every ID on new line': 'Every ID on new line',
  'View Report #': 'View Report #',
  // Reports names
  'Order Items Profit & Loss': 'Order Items Profit & Loss',
  'Amazon competitors': 'Amazon competitors',
  'Markets inventory differences': 'Markets inventory differences',

  /**
   * RePricer
   */
  'Filter by sku...': 'Filter by sku...',
  'Fullfiled By Amazon': 'Fullfiled By Amazon',
  'Shipping time in hours': 'Shipping time in hours',

  /**
   * Settings
   */
  'Minimum vendor Qty': 'Minimum vendor Qty',
  'Change minimal margin': 'Change minimal margin',
  '"0" - use default margin, "-1" - don\'t send price': '"0" - use default margin, "-1" - don\'t send price',
  'Market fee, %': 'Market fee, %',
  'Margin min, %': 'Margin min, %',
  'Margin max, %': 'Margin max, %',
  'Marketplace Credentials': 'Marketplace Credentials',

  /**
   * Login page
   */
  'Sign In to your account': 'Sign In to your account',
  'You are already logged in your account.': 'You are already logged in your account.',
  'Go to account': 'Go to account',
  'Sign up': 'Sign up',
  'Sorry. It is not available now!': 'Sorry. It is not available now!',
  'Login and/or password are incorrect.': 'Email and/or password are incorrect.',

  /**
   * Dashboard
   */
  'Summary statistics from to': 'Summary statistics from {from} to {to}',
  'New Orders': 'New Orders',
  'Ready to ship': 'Ready to ship',
  'Orders Shipped': 'Orders Shipped',
  'Orders canceled': 'Canceled',
  'Problem Orders': 'Problem Orders',
  'Orders Summary': 'Orders Summary',
  'Orders by marketplaces': 'Orders by marketplaces',
  'Select an interval': 'Select an interval',

  /**
   * Categories
   */
  'Bind marketplaces': 'Bind marketplaces',
  'Bind to': 'Bind to',
  'Is allowed for listings': 'Is allowed for listings',

  /**
   * Templates
   */
  'Template Editor': 'Template Editor',

  /**
   * Breadcrumbs
   */
  Breadcrumbs_Dashboard: 'Dashboard',
  Breadcrumbs_Marketplaces: 'Marketplaces',
  Breadcrumbs_Categories: 'Categories',
  Breadcrumbs_Accounts: 'Accounts',
  Breadcrumbs_Users: 'Users',
  Breadcrumbs_Products: 'Products',
  'Breadcrumbs_Colors Maps': 'Colors Maps',
  'Breadcrumbs_Sizes Maps': 'Sizes Maps',
};
